"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _clone2 = _interopRequireDefault(require("lodash/clone"));

var _ControlledBlurInput = _interopRequireDefault(require("./ControlledBlurInput"));

/* An input that only sends changes
 * to its parent on blur and maintains its own value while focused.
 */
var BlurInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(BlurInput, _React$Component);

  function BlurInput(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, BlurInput);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BlurInput).call(this, props));
    _this.state = {
      value: typeof _this.props.value !== 'undefined' ? _this.props.value : ''
    };
    _this.setInputElement = _this.setInputElement.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    return _this;
  }

  (0, _createClass2["default"])(BlurInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var autoComplete = this.props.autoComplete;
      var isAutoCompletePollingEnabled = !(/^(false|off)$/.test(autoComplete) || !autoComplete);
      var currentInputHasFocus = this.state.input === document.activeElement; // Input value should not update if autocomplete is on and the current input has focus.
      // Without this, changes to input fields as a result of an autocomplete trigger
      // a rerender which in turn resets inputs whose values have yet to set in state.
      // This filters when the value update should trigger a subsequent rerender.

      if (isAutoCompletePollingEnabled && currentInputHasFocus) {
        return;
      }

      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _isEqual2["default"])(nextProps, this.props) || !(0, _isEqual2["default"])(nextState, this.state) || this.props.value !== this.state.value;
    }
    /**
     * DEPRECATED. This is an anti-pattern and should not be used.
     */

  }, {
    key: "value",
    value: function value() {
      return this.state.value;
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        value: e.target.value
      });

      if (typeof this.props.debounceMs === 'number') {
        this.deb = this.deb || (0, _debounce2["default"])(this.props.onChange, this.props.debounceMs);
        this.deb((0, _clone2["default"])(e));
      }

      e.stopPropagation();
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (this.props.value !== this.state.value) {
        this.props.onChange(e);
      }

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
    /**
     * Used to retrieve current input from ControlledBlurInput
     */

  }, {
    key: "setInputElement",
    value: function setInputElement(input) {
      this.setState({
        input: input
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          debounceMs = _this$props.debounceMs,
          inputProps = (0, _objectWithoutProperties2["default"])(_this$props, ["debounceMs"]); // eslint-disable-line no-unused-vars

      var props = (0, _objectSpread2["default"])({}, inputProps, {
        value: this.state.value,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onSetInput: this.setInputElement
      });
      return _react["default"].createElement(_ControlledBlurInput["default"], props);
    }
  }]);
  return BlurInput;
}(_react["default"].Component);

exports["default"] = BlurInput;
BlurInput.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  onKeyPress: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  value: _propTypes["default"].string,
  debounceMs: _propTypes["default"].number,
  textarea: _propTypes["default"].bool,
  autoComplete: _propTypes["default"].string
} : {};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/util/BlurInput.js
// module id = 407
// module chunks = 0